import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdMessagingRules = "/apps/:app_group_id/messaging_rules";

export const appsAppGroupIdMessagingRulesCacheKeys: AllRouteEndpoints[] = [appsAppGroupIdMessagingRules];
